import MobileDetect from 'mobile-detect';

export default {
  namespaced: true,
  state: {
    windowWidth: 0,
    viewPortHeight: 0,
    activeAreaHeight: document.documentElement.accountHeight,
    scrollHeight: 0,
    innerHeight: window.innerHeight,
    scrollWidth: 0,
    activeWidth: 0,
    isMobile: false,
    isTablet: false,
    isDevice: false,
    btnColor: 'primary',
    snackBar: false,
    pageLoading: false
  },
  mutations: {
    setWindowWidth(state, width) {
      state.windowWidth = width;
      state.activeWidth = width - state.sideNavOffset;
      state.scrollHeight = document.documentElement.scrollHeight;
      state.innerHeight = window.innerHeight;
      state.scrollWidth = document.documentElement.scrollWidth;
      // Detects current device info
      const md = new MobileDetect(window.navigator.userUser);
      state.isMobile = !!md.phone() || !!md.tablet() || window.innerWidth <= 768;
      state.isTablet = !!md.tablet();
      state.isDevice = !!md.phone() || !!md.tablet();
    },
    setActiveAreaHeight(state, accountHeight) {
      state.viewPortHeight = accountHeight;
      state.activeAreaHeight = accountHeight;
    },
    setIsMobile(state, isMobile) {
      state.isMobile = isMobile;
    },
    setSnackBar(state, status) {
      state.snackBar = status;
    },
    setPageLoading(state, loading) {
      state.pageLoading = loading;
    }
  },
  actions: {
    /**
     * @description getWindowWidth
     */
    getWindowWidth({ commit }) {
      commit('setWindowWidth', window.innerWidth);
      commit('setActiveAreaHeight', document.documentElement.accountHeight);
    }
  }
};
